// FacturaPicker - S48.2b.
// Input numerico para el ID de factura + boton 'Cargar factura'. Cuando
// hay factura cargada, muestra meta basica (numero) y un boton 'Quitar
// factura' que vuelve la pagina a su modo previo.
//
// Props:
//   factura: objeto venta cargado o null.
//   loading: bool indicando fetch en curso.
//   error: string|null con mensaje de error.
//   onLoad(id): handler invocado con el id numerico al pulsar 'Cargar'.
//   onClear(): handler para deseleccionar la factura.
import { useEffect, useState } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLInput from '../../../components/xl/XLInput';

const CSS_ID = 'xl-et-facturapicker-css';
const CSS = `
.xl-et-facpic { display: inline-flex; align-items: flex-end; gap: 8px; flex-wrap: wrap }
.xl-et-facpic__input { min-width: 120px }
.xl-et-facpic__btn {
  font: 500 13px/1 var(--xl-font-sans); padding: 10px 16px;
  border-radius: var(--xl-radius-md);
  border: 1px solid var(--xl-color-border);
  background: transparent; color: var(--xl-color-text-secondary);
  cursor: pointer;
  transition: background 120ms cubic-bezier(0,0,0.2,1), border-color 120ms cubic-bezier(0,0,0.2,1);
}
.xl-et-facpic__btn:hover {
  background: var(--xl-color-surface);
  color: var(--xl-color-text);
  border-color: rgba(46, 55, 69, 0.25);
}
.xl-et-facpic__btn:focus-visible { outline: 2px solid var(--xl-color-focus); outline-offset: 2px }
.xl-et-facpic__btn:disabled { opacity: 0.45; cursor: not-allowed }
.xl-et-facpic__btn--primary {
  background: var(--xl-color-primary); color: var(--xl-color-text-inverse);
  border-color: var(--xl-color-primary);
}
.xl-et-facpic__btn--primary:hover { background: var(--xl-color-primary-hover) }
.xl-et-facpic__msg { font: 500 12px/1.2 var(--xl-font-sans); color: var(--xl-color-text-muted) }
.xl-et-facpic__msg--err { color: var(--xl-color-danger) }
.xl-et-facpic__num { font: 500 12px/1 var(--xl-font-mono); color: var(--xl-color-text-secondary) }
`;

export default function FacturaPicker({ factura, loading, error, onLoad, onClear }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const [val, setVal] = useState('');

  const handleLoad = () => {
    const n = Number(val);
    if (!Number.isFinite(n) || n <= 0) return;
    if (typeof onLoad === 'function') onLoad(n);
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleLoad();
    }
  };

  const handleClear = () => {
    setVal('');
    if (typeof onClear === 'function') onClear();
  };

  return (
    <div className="xl-et-facpic">
      <div className="xl-et-facpic__input">
        <XLInput
          label="ID de factura"
          type="number"
          min="1"
          step="1"
          value={val}
          onChange={(e) => setVal(e.target.value)}
          onKeyDown={handleKey}
          placeholder="Ej. 1234"
          disabled={!!loading}
        />
      </div>
      <button
        type="button"
        className="xl-et-facpic__btn xl-et-facpic__btn--primary"
        onClick={handleLoad}
        disabled={!!loading || !val}
      >
        {loading ? 'Cargando...' : 'Cargar factura'}
      </button>
      {factura && (
        <button
          type="button"
          className="xl-et-facpic__btn"
          onClick={handleClear}
          disabled={!!loading}
        >
          Quitar factura
        </button>
      )}
      {factura && factura.numero && (
        <span className="xl-et-facpic__num">{factura.numero}</span>
      )}
      {error && (
        <span className="xl-et-facpic__msg xl-et-facpic__msg--err">{error}</span>
      )}
    </div>
  );
}
